module.exports = __webpack_public_path__ + "media/images/download-extension-btn-f7bd05cf7e8c7cd25699b4b8c49a4538.svg";